(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ob-fitting-schedule"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ob-fitting-schedule')) {
    class ObFittingSchedule extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.locale = this.dataset.locale.startsWith('en') ? 'en-US' : 'ja-JP';
        const parts = new Intl.DateTimeFormat('en-US', { timeZone: 'Asia/Tokyo', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date());
        const part = (type) => parts.find((item) => item.type === type).value;
        this.today = part('year') + '-' + part('month') + '-' + part('day');
        this.source = this.querySelector('.ob-schedule__source');
        this.events = [...this.source.querySelectorAll('[data-event-date]')].filter((card) => card.dataset.eventDate >= this.today).sort((a, b) => a.dataset.eventDate.localeCompare(b.dataset.eventDate));
        this.dialog = this.querySelector('dialog');
        const currentMonth = this.today.slice(0, 7);
        const firstDate = this.events.some((card) => card.dataset.eventDate.startsWith(currentMonth)) ? this.today : this.events[0]?.dataset.eventDate || this.today;
        this.year = Number(firstDate.slice(0, 4));
        this.month = Number(firstDate.slice(5, 7)) - 1;
        this.addEventListener('click', (event) => {
          const button = event.target.closest('button');
          if (!button || !this.contains(button)) return;
          if (button.hasAttribute('data-shift')) {
            const date = new Date(Date.UTC(this.year, this.month + Number(button.dataset.shift), 1));
            this.year = date.getUTCFullYear();
            this.month = date.getUTCMonth();
            this.render();
          } else if (button.hasAttribute('data-current')) {
            this.year = Number(this.today.slice(0, 4));
            this.month = Number(this.today.slice(5, 7)) - 1;
            this.render();
          } else if (button.hasAttribute('data-event-index')) {
            const card = this.events[Number(button.dataset.eventIndex)];
            if (!card) return;
            this.trigger = button;
            this.dialog.querySelector('[data-dialog-content]').replaceChildren(card.cloneNode(true));
            this.dialog.showModal();
          } else if (button.hasAttribute('data-close')) {
            this.dialog.close();
          }
        });
        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.dialog.close();
        });
        this.dialog.addEventListener('close', () => this.trigger?.focus());
        this.render();
        this.source.hidden = true;
        this.querySelector('.ob-schedule__calendar').hidden = false;
      }
      textElement(tag, className, text) {
        const element = document.createElement(tag);
        element.className = className;
        element.textContent = text;
        return element;
      }
      render() {
        const prefix = this.year + '-' + String(this.month + 1).padStart(2, '0');
        const formatter = new Intl.DateTimeFormat(this.locale, { timeZone: 'UTC', year: 'numeric', month: 'long' });
        const label = formatter.format(new Date(Date.UTC(this.year, this.month, 1)));
        this.querySelector('.ob-schedule__month').textContent = label;
        const table = document.createElement('table');
        table.className = 'ob-schedule__grid';
        table.setAttribute('aria-label', label);
        const headRow = table.createTHead().insertRow();
        this.dataset.weekdays.split(',').forEach((day) => {
          const th = this.textElement('th', '', day);
          th.scope = 'col';
          headRow.append(th);
        });
        const body = table.createTBody();
        const offset = new Date(Date.UTC(this.year, this.month, 1)).getUTCDay();
        const days = new Date(Date.UTC(this.year, this.month + 1, 0)).getUTCDate();
        const cellCount = Math.ceil((offset + days) / 7) * 7;
        let row;
        for (let index = 0; index < cellCount; index += 1) {
          if (index % 7 === 0) row = body.insertRow();
          const cell = row.insertCell();
          const day = index - offset + 1;
          if (day < 1 || day > days) {
            cell.className = 'ob-schedule__blank';
            continue;
          }
          const iso = prefix + '-' + String(day).padStart(2, '0');
          const dayLabel = this.textElement('time', 'ob-schedule__day', String(day));
          dayLabel.dateTime = iso;
          if (iso === this.today) dayLabel.setAttribute('aria-current', 'date');
          if (iso < this.today) cell.classList.add('ob-schedule__past');
          cell.append(dayLabel);
          this.events.forEach((card, eventIndex) => {
            const data = card.dataset;
            if (data.eventDate !== iso) return;
            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'ob-schedule__session ob-schedule__session--' + data.eventStatus;
            button.dataset.eventIndex = String(eventIndex);
            button.setAttribute('aria-haspopup', 'dialog');
            button.setAttribute('aria-label', iso + ' ' + data.eventArea + ' ' + data.statusLabel + (data.compactTime ? ' ' + data.compactTime : ''));
            button.append(this.textElement('span', 'ob-schedule__area', data.eventArea));
            button.append(this.textElement('span', 'ob-schedule__availability', data.compactStatus));
            if (data.eventStatus === 'waitlist') {
              const waitlist = document.createElement('span');
              waitlist.className = 'ob-schedule__waitlist';
              waitlist.append(this.textElement('span', 'ob-schedule__long', data.waitlistLabel));
              waitlist.append(this.textElement('span', 'ob-schedule__short', data.waitlistShort));
              button.append(waitlist);
            }
            if (data.compactTime) button.append(this.textElement('span', 'ob-schedule__time', data.compactTime));
            cell.append(button);
          });
        }
        this.querySelector('.ob-schedule__table-wrap').replaceChildren(table);
        this.querySelector('.ob-schedule__empty').hidden = this.events.some((card) => card.dataset.eventDate.startsWith(prefix));
      }
    }
    customElements.define('ob-fitting-schedule', ObFittingSchedule);
  }

  } catch(e) { console.error(e); }
})();
})();
